import { useNavigate, useParams, Link } from 'react-router-dom';
import { useCreateProject } from '../../hooks/useProjects';
import { ProjectForm } from '../../components/projects/ProjectForm';
import type { CreateProjectRequest } from '../../types/project';
import './ProjectFormPage.css';

export function CreateProjectPage() {
  const navigate = useNavigate();
  const { orgId } = useParams<{ orgId: string }>();
  const createProject = useCreateProject();

  const handleSubmit = async (data: CreateProjectRequest) => {
    if (!orgId) return;

    const project = await createProject.mutateAsync({
      organizationId: orgId,
      data,
    });
    navigate(`/projects/${project.id}`);
  };

  const handleCancel = () => {
    navigate(`/organizations/${orgId}/projects`);
  };

  if (!orgId) {
    return (
      <div className="project-form-page">
        <div className="project-form-page__error">
          <p>Organization not found</p>
          <Link to="/organizations" className="btn btn--secondary">
            Go to Organizations
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="project-form-page">
      <header className="project-form-page__header">
        <div className="project-form-page__breadcrumb">
          <Link to={`/organizations/${orgId}/projects`}>Projects</Link>
          <span>/</span>
          <span>Create Project</span>
        </div>
        <h1>Create Project</h1>
        <p className="project-form-page__subtitle">
          Set up a new project to configure authentication for your application.
        </p>
      </header>

      <div className="project-form-page__content">
        <ProjectForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={createProject.isPending}
          error={createProject.error?.message}
        />
      </div>
    </div>
  );
}
